<template>
  <div id="CreateUpdateTrip">
    <v-dialog max-width="1200" hide-overlay fullscreen persistent v-model="tripDialog">
      <v-stepper style="height: 100%" v-model="currentStep">
        <v-stepper-header class="elevation-0 mt-3">
          <v-stepper-step :complete="currentStep > 1" step="1">Create Trip</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="2">Load Products</v-stepper-step>
        </v-stepper-header>
        <v-stepper-items>
          <v-stepper-content step="1">
            <v-card width="500px" class="mx-auto elevation-0">
              <v-card-text>
                <v-form ref="form1">
                  <v-autocomplete :items="routes" :rules="[rules.routeRequired]"
                                  @change="changeRouteData" clearable item-text="name" item-value="id"
                                  label="Select Route" outlined return-object
                                  v-model="tripData.routeId"></v-autocomplete>
                  <v-autocomplete :items="drivers" :rules="[rules.driverRequired]" clearable
                                  item-text="name" item-value="id" label="Select Salesman"
                                  outlined v-model="tripData.driverId"></v-autocomplete>
                  <v-autocomplete :items="vehicles" :rules="[rules.vehicleRequired]" clearable
                                  item-text="name" item-value="id" label="Select Vehicle"
                                  outlined v-model="tripData.vehicleId">
                    <template v-slot:selection="data">
                      {{ data.item.name }} ({{ data.item.platNo }})
                    </template>
                    <template v-slot:item="data">
                      <v-list-item-content>
                        <v-list-item-title v-html="data.item.name"></v-list-item-title>
                        <v-list-item-subtitle v-html="data.item.platNo"></v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </v-form>
              </v-card-text>
              <v-card-actions class="pa-3">
                <v-spacer></v-spacer>
                <v-btn @click="cancel" class="mr-2 white elevation-0">CANCEL</v-btn>
                <v-btn @click="goNext" class="mr-2 primary elevation-0">NEXT</v-btn>
              </v-card-actions>
            </v-card>
          </v-stepper-content>
          <v-stepper-content step="2">
            <v-card>
              <v-card-text v-if="productMapped">
                <v-text-field class=" pt-1 col-4" dense outlined label="Search Product" @input="searchProduct"
                              clearable></v-text-field>
                <v-form ref="form2" style="height: 66vh;overflow-x: auto">
                  <v-card class="py-0" :key="index" v-for="(product,index) in products" elevation="0">
                    <v-card-text class="py-0">
                      <v-row class="align-center">
                        <v-col cols="1" class="text-center px-2">
                          <v-img class="d-block mx-auto" :src="product.image?product.image:'../src/assets/logo.png'"
                                 contain width="50"></v-img>
                          <v-chip label text-color="white" x-small v-if="product.packageType"
                                  :style="`background-color: ${packageColor[product.packageType]}`" class="mt-3">
                            {{ product.packageType.toUpperCase() }}
                          </v-chip>
                        </v-col>

                        <v-col cols="4">
                          <h6 class="text-subtitle-1 font-weight-bold" :style="{color:product.colorCode}">
                            {{ product.displayName }} ({{ product.weight }} gm)</h6>
                          <p class="text-left mb-1 font-weight-medium ">
                            {{ product.boxes.stock }} {{product.containerType}}es , {{ product.packets.stock }} Packets
                          </p>
                          <p class="text-caption font-italic mb-0">{{ product.noOfPieceInBox }} Pieces in {{product.containerType}}</p>
                        </v-col>

                        <v-col cols="2">
                          <strong class="text-left mb-0 d-block">Opening Stock</strong>
                          <p class="text-left mb-0">
                            {{ product.boxes.openingStock }} {{product.containerType}}es , {{ product.packets.openingStock }} Packets
                          </p>
                        </v-col>
                        <v-col cols="3" class="d-flex">
                          <v-row class="justify-end mr-3 align-center"
                                 v-if="product.boxes.stock || product.packets.stock">
                            <div class="mr-3">
                              <p class="mb-0 text-caption">{{product.containerType}}es</p>
                              <v-text-field style="width: 100px;" class="text-center stock-field"
                                            @click:prepend-inner="decreaseProductUnit(index,'boxes')"
                                            @click:append="increaseProductUnit(index,'boxes')"
                                            @input="changeProductUnit('boxes',$event,index)"
                                            append-icon="mdi-plus" dense flat hide-details outlined
                                            prepend-inner-icon="mdi-minus"
                                            v-model="product.boxes.quantity"></v-text-field>
                            </div>
                            <div>
                              <p class="mb-0 text-caption">Packets</p>
                              <v-text-field style="width: 100px;" class="text-center stock-field"
                                            @click:prepend-inner="decreaseProductUnit(index,'packets')"
                                            @click:append="increaseProductUnit(index,'packets')"
                                            @input="changeProductUnit('packets',$event,index)"
                                            append-icon="mdi-plus" dense flat hide-details outlined
                                            prepend-inner-icon="mdi-minus"
                                            v-model="product.packets.quantity"></v-text-field>
                            </div>
                          </v-row>
                          <v-row v-else>
                            <v-col cols="12" class="text-center error--text">
                              Stock Unavailable
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="2">
                          <strong class="text-left mb-0 d-block">Final Stock</strong>
                          <p class="text-left mb-0">
                            {{ product.boxes.finalStock }} {{product.containerType}}es , {{ product.packets.finalStock }} Packets
                          </p>
                        </v-col>
                        <v-col cols="12" class="py-0">
                          <v-divider></v-divider>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-form>
              </v-card-text>
              <v-card-actions class="pa-3">
                <v-btn @click="currentStep=1" outlined>PREVIOUS</v-btn>
                <v-spacer></v-spacer>
                <div v-if="productMapped">
                  <strong class="mr-2">Stock</strong>{{ calculateBox() }} Boxes {{ calculatePiece() }}
                  Pieces
                </div>
                <v-spacer></v-spacer>
                <v-btn @click="cancel" class="mr-2 white elevation-0">CANCEL</v-btn>
                <v-btn @click="validate" class="mr-2 primary elevation-0">SAVE</v-btn>
              </v-card-actions>
            </v-card>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-dialog>
    <Snackbar :toaster="toaster"></Snackbar>
  </div>
</template>

<script>

import { GET_USERS_BY_TYPE } from '@/graphql/queries/Users'
import { IDS } from '@/Constants/IDS'
import { GET_VEHICLES_BY_TYPE } from '@/graphql/queries/Vehicles'
import { GET_ALL_PRODUCTS } from '../../graphql/queries/Products'
import { GET_ORGANIZATION_STOCK_BY_ID } from '../../graphql/queries/OrganizationStock'
import {
  CREATE_UPDATE_OPENING_TRIP_ORG_STOCK,
  CREATE_UPDATE_TRIP_ORG_STOCK,
  UPDATE_TRIP_CURRENT_STOCK,
} from '../../graphql/mutations/Trips'
import {
  GET_DRIVER_CURRENT_TRIP, GET_OPENING_TRIP_BY_VEHICLE,
  GET_SHOP_LAST_VISITED,
  GET_TRIP_COUNT, GET_VEHICLE_CURRENT_TRIP,
} from '../../graphql/queries/Trips'
import moment from 'moment'
import { SUBSCRIBE_ROUTES } from '@/graphql/subscriptions/Routes'
import Snackbar from '@/components/Common/Snackbar'

export default {
  name: 'CreateUpdateTrip', components: { Snackbar },
  props: { trip: { type: [Object], default: null }, tripDialog: { type: [Boolean], default: false } },
  apollo: {
    Users: {
      query: GET_USERS_BY_TYPE, fetchPolicy: 'network-only',
      skip () {
        return !this.loggedInUser
      },
      variables () {
        return { orgId: this.loggedInUser.organizationId, userTypeId: IDS.userTypes.Driver }
      },
      result ({ data, loading }) {
        if (!loading) {
          this.drivers = data.Users
        }
      },
    },
    Vehicles: {
      query: GET_VEHICLES_BY_TYPE, fetchPolicy: 'network-only',
      skip () {
        return !this.loggedInUser
      },
      variables () {
        return { orgId: this.loggedInUser.organizationId, vehicleType: IDS.vehicleType.Tempo }
      },
      result ({ data, loading }) {
        if (!loading) {
          this.vehicles = data.Vehicles
        }
      },
    },
    $subscribe: {
      Routes: {
        query: SUBSCRIBE_ROUTES, fetchPolicy: 'network-only',
        skip () {
          return !this.loggedInUser
        },
        variables () {
          return { orgId: this.loggedInUser.organizationId }
        },
        result ({ data, loading }) {
          if (!loading) {
            this.routes = data.Routes
          }
        },
      },
    },
    Products: {
      query: GET_ALL_PRODUCTS, fetchPolicy: 'network-only',
      result ({ data, loading }) {
        if (!loading) {
          this.products = data.Products
          this.loading.product = false
        }
      },
    },
    OrganizationStock: {
      query: GET_ORGANIZATION_STOCK_BY_ID, fetchPolicy: 'network-only',
      skip () {
        return (!this.loggedInUser || !this.products.length) && this.isProductSearched
      },
      variables () {
        return { id: this.loggedInUser.organizationId }
      },
      result ({ data, loading }) {
        if (!loading) {
          this.organizationStock = data.OrganizationStock
          this.loading.stock = false
          this.$forceUpdate()
          setTimeout(() => this.mapProductStocks(), 100)
        }
      },
    },
    TripCount: {
      query: GET_TRIP_COUNT, fetchPolicy: 'network-only',
      result ({ data, loading }) {
        if (!loading) {
          this.tripCount = data.TripCount.aggregate.count + 1
        }
      },
    },
  },
  data () {
    return {
      tripCount: 0, tripId: '', currentStep: 1,
      drivers: [], vehicles: [], routes: [], products: [], tempProducts: [],
      loading: { product: true, stock: true },
      tripData: { routeId: '', driverId: '', vehicleId: '', organizationId: '', routeShops: [] },
      organizationStock: [], openingTrip: null,
      productMapped: false, isProductSearched: false,
      loggedInUser: JSON.parse(localStorage.user),
      rules: {
        routeRequired: value => !!value || 'Route Required.',
        vehicleRequired: value => !!value || 'Vehicle Required.',
        driverRequired: value => !!value || 'Salesman Required.',
      },
      toaster: { message: '', color: 'red', enable: false },
      packageColor: JSON.parse(localStorage.packageColor),
    }
  },
  mounted () {
    if (this.trip) this.tripData = JSON.parse(JSON.stringify(this.trip))
    else this.tripData['id'] = this.generateUUID()
  },
  methods: {
    changeRouteData (obj) {
      this.tripData.routeId = obj.id
      this.tripData.vehicleId = obj.vehicleId
      this.tripData.driverId = obj.driverId
      this.tripData.routeShops = obj.RouteShops
    },
    mapProductStocks () {
      if (this.loading.product === false && this.loading.stock === false) {
        this.products.forEach(product => {
          product.packets = {
            quantity: 0, stock: 0, oldTripStock: 0, openingStock: 0, finalStock: 0, unitId: IDS.unitType.Piece,
          }
          product.boxes = {
            quantity: 0, stock: 0, oldTripStock: 0, openingStock: 0, finalStock: 0, unitId: IDS.unitType.Box,
          }
        })
        this.$forceUpdate()
        this.products.forEach(product => {
          this.organizationStock.forEach(orgStock => {
            if (orgStock.productId === product.id) {
              if (orgStock.unitId === IDS.unitType.Piece) {
                product.packets.stock = orgStock.quantity ? (orgStock.quantity - orgStock.reservedQuantity) : 0
                product.organizationStockId_packets = orgStock.id
              } else if (orgStock.unitId === IDS.unitType.Box) {
                product.boxes.stock = orgStock.quantity ? (orgStock.quantity - orgStock.reservedQuantity) : 0
                product.organizationStockId_boxes = orgStock.id
              }
            }
          })
        })
        if (this.openingTrip) {
          this.mapOpeningTripStock()
        }
        this.$forceUpdate()
        this.tempProducts = JSON.parse(JSON.stringify(this.products))
        this.productMapped = true
        this.$forceUpdate()
      }
    },
    mapOpeningTripStock () {
      this.products.forEach(product => {
        this.openingTrip.VehicleTripStock.forEach(vehicleTripStock => {
          if (vehicleTripStock.productId === product.id) {
            if (vehicleTripStock.unitId === IDS.unitType.Piece) {
              product.packets.oldTripStock = vehicleTripStock.currentQty ? vehicleTripStock.currentQty : 0
              product.packets.openingStock = vehicleTripStock.currentQty ? vehicleTripStock.currentQty : 0
              product.packets.finalStock = vehicleTripStock.currentQty ? vehicleTripStock.currentQty : 0
              product.packets.quantity = 0
            } else if (vehicleTripStock.unitId === IDS.unitType.Box) {
              product.boxes.oldTripStock = vehicleTripStock.currentQty ? vehicleTripStock.currentQty : 0
              product.boxes.openingStock = vehicleTripStock.currentQty ? vehicleTripStock.currentQty : 0
              product.boxes.finalStock = vehicleTripStock.currentQty ? vehicleTripStock.currentQty : 0
              product.boxes.quantity = 0
            }
          }
        })
      })
      this.$forceUpdate()
      this.tempProducts = JSON.parse(JSON.stringify(this.products))
      this.productMapped = true
      this.$forceUpdate()
    },
    async goNext () {
      if (this.$refs.form1.validate()) {
        let res1 = await this.$apollo.query({
          query: GET_DRIVER_CURRENT_TRIP, fetchPolicy: 'network-only', variables: { driverId: this.tripData.driverId },
        })
        let res2 = await this.$apollo.query({
          query: GET_VEHICLE_CURRENT_TRIP, fetchPolicy: 'network-only',
          variables: { vehicleId: this.tripData.vehicleId },
        })
        if (res1.data.VehicleTrip.length) {
          this.toaster = { enable: true, message: 'Salesman is already assigned', color: 'red' }
        } else if (res2.data.VehicleTrip.length) {
          this.toaster = { enable: true, message: 'Vehicle is already assigned', color: 'red' }
        } else {
          let res3 = await this.$apollo.query({
            query: GET_OPENING_TRIP_BY_VEHICLE, fetchPolicy: 'network-only',
            variables: { vehicleId: this.tripData.vehicleId },
          })
          if (res3.data) {
            this.openingTrip = res3.data.VehicleTrip.length ? res3.data.VehicleTrip[0] : null
            if (this.openingTrip) this.mapOpeningTripStock()
            this.currentStep = 2
          }
        }
      }
    },
    validate () {
      if (this.$refs.form2.validate()) {
        let vehicleNo = this.vehicles.filter(vehicle => vehicle.id === this.tripData.vehicleId)[0].platNo
        this.tripId = `${vehicleNo.replace(/ /g, '')}-${moment().format('DDMMYYYY')}-${this.tripCount.toString().
            padStart(3, '0')}`
        this.openingTrip ? this.saveOpeningTrip() : this.saveTrip()
      }
    },
    increaseProductUnit (index, unit) {
      if (unit === 'boxes') {
        if (this.products[index][unit].stock > this.products[index][unit].quantity) {
          this.products[index][unit].quantity = parseInt(this.products[index][unit].quantity) + 1
        }
      } else if (unit === 'packets') {
        if (this.products[index]['boxes'].stock > this.products[index]['boxes'].quantity) {
          if (this.products[index][unit].quantity >= this.products[index].bunchKg) {
            this.products[index][unit].quantity = 1
            this.products[index]['boxes'].quantity = parseInt(this.products[index]['boxes'].quantity) + 1
          } else {
            this.products[index][unit].quantity = parseInt(this.products[index][unit].quantity) + 1
          }
        } else {
          if (this.products[index][unit].stock > this.products[index][unit].quantity) {
            this.products[index][unit].quantity = parseInt(this.products[index][unit].quantity) + 1
          }
        }
      }
      this.$forceUpdate()
      this.calculateFinalStock(index)
    },
    decreaseProductUnit (index, unit) {
      if (this.products[index][unit].quantity) {
        this.products[index][unit].quantity = parseInt(this.products[index][unit].quantity) - 1
        this.$forceUpdate()
      }
      this.calculateFinalStock(index)
    },
    changeProductUnit (unit, event, index) {
      let self = this
      event = event ? parseInt(event) : 0
      if (unit === 'boxes') {
        if (this.products[index][unit].stock > parseInt(this.products[index][unit].quantity)) {
          setTimeout(function () {
            self.products[index][unit].quantity = event
            self.calculateFinalStock(index)
            self.$forceUpdate()
          }, 100)
        } else {
          setTimeout(function () {
            self.products[index][unit].quantity = event > 0 ? parseInt(self.products[index][unit].stock) : 0
            self.calculateFinalStock(index)
            self.$forceUpdate()
          }, 100)
        }
      } else if (unit === 'packets') {
        if (this.products[index]['boxes'].stock > parseInt(event)) {
          if (event >= this.products[index].bunchKg) {
            setTimeout(function () {
              self.products[index][unit].quantity = Math.floor(event % parseInt(self.products[index].bunchKg))
              self.products[index]['boxes'].quantity = parseInt(self.products[index]['boxes'].quantity) +
                  Math.floor(event / parseInt(self.products[index].bunchKg))
              self.calculateFinalStock(index)
              self.changeProductUnit('boxes', self.products[index]['boxes'].quantity, index)
            }, 100)
          } else {
            setTimeout(function () {
              self.products[index][unit].quantity = event
              self.calculateFinalStock(index)
              self.$forceUpdate()
            }, 100)
          }
        } else {
          if (this.products[index][unit].stock > parseInt(this.products[index][unit].quantity)) {
            setTimeout(function () {
              self.products[index][unit].quantity = event
              self.calculateFinalStock(index)
              self.$forceUpdate()
            }, 100)
          } else {
            setTimeout(function () {
              self.products[index][unit].quantity = event > 0 ? parseInt(self.products[index][unit].stock) : 0
              self.calculateFinalStock(index)
              self.$forceUpdate()
            }, 100)
          }
        }
      }
      this.$forceUpdate()
    },
    calculateFinalStock (index) {
      this.products[index]['packets'].finalStock = parseInt(this.products[index]['packets'].openingStock) +
          parseInt(this.products[index]['packets'].quantity)
      this.products[index]['boxes'].finalStock = parseInt(this.products[index]['boxes'].openingStock) +
          parseInt(this.products[index]['boxes'].quantity)
      this.$forceUpdate()
    },
    async saveTrip () {
      if (this.calculateBox() || this.calculatePiece()) {
        let tripObj = {
          id: this.tripData.id, routeId: this.tripData.routeId, type:'READY-STOCK',
          driverId: this.tripData.driverId, vehicleId: this.tripData.vehicleId,
          organizationId: this.loggedInUser.organizationId, createdBy: this.loggedInUser.id,
        }
        let tripStock = [], tripDestinations = [], orgStock = []
        let shopIds = this.tripData.routeShops.map(routeShop => routeShop.Organization.id)
        let res = await this.$apollo.query({
          query: GET_SHOP_LAST_VISITED, fetchPolicy: 'network-only',
          variables: { shopIds: shopIds, orgId: this.loggedInUser.organizationId },
        })
        let allTripDestinations = res.data.TripDestinations

        // eslint-disable-next-line no-inner-declarations
        function getLastVisitedByShopId (shopId) {
          let shopEntries = allTripDestinations.filter(destination => destination.shopId === shopId)
          return shopEntries.length ? shopEntries[0].checkInTime : null
        }

        this.tripData.routeShops.forEach(routeShop => {
          tripDestinations.push({
            sequence: routeShop.sequence, shopId: routeShop.Organization.id,
            shopName: routeShop.Organization.name, vehicleTripId: this.tripData.id,
            lastVisitedDate: getLastVisitedByShopId(routeShop.Organization.id), status: 'NOT_VISITED',
          })
        })
        this.products.forEach(product => {
          if (product.packets.finalStock || product.boxes.finalStock) {
            tripStock.push({
              vehicleTripId: this.tripData.id, productId: product.id, unitId: product.packets.unitId,
              initialQty: product.packets.finalStock, currentQty: product.packets.finalStock, unloadedQty: 0,
            }, {
              vehicleTripId: this.tripData.id, productId: product.id, unitId: product.boxes.unitId,
              initialQty: product.boxes.finalStock, currentQty: product.boxes.finalStock, unloadedQty: 0,
            })
            if (product.packets.stock < product.packets.finalStock) {
              orgStock.push(
                  {
                    id: product.organizationStockId_packets, organizationId: this.loggedInUser.organizationId,
                    productId: product.id, unitId: product.packets.unitId,
                    quantity: parseInt(product.bunchKg) - product.packets.finalStock,
                  },
                  {
                    id: product.organizationStockId_boxes, organizationId: this.loggedInUser.organizationId,
                    productId: product.id, unitId: product.boxes.unitId,
                    quantity: (product.boxes.stock - product.boxes.finalStock) - 1,
                  },
              )
            } else {
              orgStock.push(
                  {
                    id: product.organizationStockId_packets, organizationId: this.loggedInUser.organizationId,
                    productId: product.id, unitId: product.packets.unitId,
                    quantity: product.packets.stock - product.packets.finalStock,
                  },
                  {
                    id: product.organizationStockId_boxes, organizationId: this.loggedInUser.organizationId,
                    productId: product.id, unitId: product.boxes.unitId,
                    quantity: product.boxes.stock - product.boxes.finalStock,
                  },
              )
            }
          }
        })
        let trip_on_conflict_rule = {
          constraint: 'VehicleTrip_pkey',
          update_columns: ['tripId', 'routeId', 'driverId', 'vehicleId', 'organizationId'],
        }
        let tripStock_on_conflict_rule = {
          constraint: 'VehicleTripStock_pkey',
          update_columns: ['vehicleTripId', 'productId', 'unitId', 'initialQty', 'currentQty', 'unloadedQty'],
        }
        let orgStock_on_conflict_rule = {
          constraint: 'OrganizationStock_pkey',
          update_columns: ['organizationId', 'productId', 'quantity', 'unitId'],
        }
        let tripDestinations_on_conflict_rule = {
          constraint: 'TripDestinations_pkey',
          update_columns: ['sequence', 'shopId', 'shopName', 'status', 'vehicleTripId', 'lastVisitedDate'],
        }
        let response = await this.$apollo.mutate({
          mutation: CREATE_UPDATE_TRIP_ORG_STOCK,
          variables: {
            trips: tripObj, trip_on_conflict_rule: trip_on_conflict_rule,
            tripStock: tripStock, tripStock_on_conflict_rule: tripStock_on_conflict_rule,
            orgStock: orgStock, orgStock_on_conflict_rule: orgStock_on_conflict_rule,
            tripDestinations: tripDestinations, tripDestinations_on_conflict_rule: tripDestinations_on_conflict_rule,
          },
        })
        if (response.data)
          this.$emit('saveTrip')
      } else {
        this.toaster = { enable: true, message: 'Please select any stock', color: 'red' }
      }
    },
    async saveOpeningTrip () {
      if (this.calculateBox() || this.calculatePiece()) {
        let tripObj = {
          id: this.tripData.id, routeId: this.tripData.routeId, type:'READY-STOCK',
          driverId: this.tripData.driverId, vehicleId: this.tripData.vehicleId,
          organizationId: this.loggedInUser.organizationId, createdBy: this.loggedInUser.id,
        }
        let tripStock = [], tripDestinations = [], orgStock = []
        let shopIds = this.tripData.routeShops.map(routeShop => routeShop.Organization.id)
        let res = await this.$apollo.query({
          query: GET_SHOP_LAST_VISITED, fetchPolicy: 'network-only',
          variables: { shopIds: shopIds, orgId: this.loggedInUser.organizationId },
        })
        let allTripDestinations = res.data.TripDestinations

        // eslint-disable-next-line no-inner-declarations
        function getLastVisitedByShopId (shopId) {
          let shopEntries = allTripDestinations.filter(destination => destination.shopId === shopId)
          return shopEntries.length ? shopEntries[0].checkInTime : null
        }

        this.tripData.routeShops.forEach(routeShop => {
          tripDestinations.push({
            sequence: routeShop.sequence, shopId: routeShop.Organization.id,
            shopName: routeShop.Organization.name, vehicleTripId: this.tripData.id,
            lastVisitedDate: getLastVisitedByShopId(routeShop.Organization.id), status: 'NOT_VISITED',
          })
        })
        this.products.forEach(product => {
          if (product.packets.finalStock || product.boxes.finalStock) {
            tripStock.push({
              vehicleTripId: this.tripData.id, productId: product.id, unitId: product.packets.unitId,
              initialQty: product.packets.finalStock, currentQty: product.packets.finalStock, unloadedQty: 0,
            }, {
              vehicleTripId: this.tripData.id, productId: product.id, unitId: product.boxes.unitId,
              initialQty: product.boxes.finalStock, currentQty: product.boxes.finalStock, unloadedQty: 0,
            })
            if (product.packets.stock < (product.packets.finalStock + product.packets.oldTripStock)) {
              orgStock.push(
                  {
                    id: product.organizationStockId_packets, organizationId: this.loggedInUser.organizationId,
                    productId: product.id, unitId: product.packets.unitId,
                    quantity: parseInt(product.bunchKg) - product.packets.finalStock + product.packets.oldTripStock,
                  },
                  {
                    id: product.organizationStockId_boxes, organizationId: this.loggedInUser.organizationId,
                    productId: product.id, unitId: product.boxes.unitId,
                    quantity: (product.boxes.stock - product.boxes.finalStock + product.boxes.oldTripStock) - 1,
                  },
              )
            } else {
              orgStock.push(
                  {
                    id: product.organizationStockId_packets, organizationId: this.loggedInUser.organizationId,
                    productId: product.id, unitId: product.packets.unitId,
                    quantity: product.packets.stock - product.packets.finalStock + product.packets.oldTripStock,
                  },
                  {
                    id: product.organizationStockId_boxes, organizationId: this.loggedInUser.organizationId,
                    productId: product.id, unitId: product.boxes.unitId,
                    quantity: product.boxes.stock - product.boxes.finalStock + product.boxes.oldTripStock,
                  },
              )
            }
          }
        })
        let trip_on_conflict_rule = {
          constraint: 'VehicleTrip_pkey',
          update_columns: ['tripId', 'routeId', 'driverId', 'vehicleId', 'organizationId'],
        }
        let tripStock_on_conflict_rule = {
          constraint: 'VehicleTripStock_pkey',
          update_columns: ['vehicleTripId', 'productId', 'unitId', 'initialQty', 'currentQty', 'unloadedQty'],
        }
        let orgStock_on_conflict_rule = {
          constraint: 'OrganizationStock_pkey',
          update_columns: ['organizationId', 'productId', 'quantity', 'unitId'],
        }
        let tripDestinations_on_conflict_rule = {
          constraint: 'TripDestinations_pkey',
          update_columns: ['sequence', 'shopId', 'shopName', 'status', 'vehicleTripId', 'lastVisitedDate'],
        }
        let response = await this.$apollo.mutate({
          mutation: CREATE_UPDATE_OPENING_TRIP_ORG_STOCK,
          variables: {
            previousTripId: this.openingTrip.id,
            trips: tripObj, trip_on_conflict_rule: trip_on_conflict_rule,
            tripStock: tripStock, tripStock_on_conflict_rule: tripStock_on_conflict_rule,
            orgStock: orgStock, orgStock_on_conflict_rule: orgStock_on_conflict_rule,
            tripDestinations: tripDestinations, tripDestinations_on_conflict_rule: tripDestinations_on_conflict_rule,
          },
        })
        if (response.data) {
          let res = await this.$apollo.mutate({
            mutation: UPDATE_TRIP_CURRENT_STOCK, variables: { tripId: this.openingTrip.id, currentQty: 0 },
          })
          if (res.data) this.$emit('saveTrip')
        }
      } else {
        this.toaster = { enable: true, message: 'Please select any stock', color: 'red' }
      }
    },
    calculateBox () {
      let total = 0
      this.products.forEach(product => {
        total += parseInt(product.boxes?.finalStock)
      })
      return total
    },
    calculatePiece () {
      let total = 0
      this.products.forEach(product => {
        total += parseInt(product.packets?.finalStock)
      })
      return total
    },
    searchProduct (val) {
      this.isProductSearched = true
      if (val)
        this.products = this.tempProducts.filter(product => {
          return (product.displayName.toLowerCase().indexOf(val.toLowerCase()) !== -1)
        })
      else
        this.products = this.tempProducts
    },
    cancel () {
      this.$emit('cancel')
    },
    generateUUID () {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8)
        return v.toString(16)
      })
    },
  },
}
</script>

<style scoped>
.PartyPack {
  background-color: #EC2144 !important;
}

.FamilyPack {
  background-color: #DAB44F !important;
}

.CouplePack {
  background-color: #45B1E6 !important;
}

.stock-field /deep/ .input {
  text-align: center !important;
}
</style>
